// =====================================
//
//   fomat商品 service
//   Author: Gray
//   createtime: 2017 / 09 / 26
//   updatetime: 2017 / 09 / 26
//
// =====================================

window.InifECShared.factory("$ProductFormatService", ['$state', function($state) {
var mainPdtClasses; // bundler：原本是隱式全域（沒有 var），strict mode 會 ReferenceError

    var factory = {};
    var pdtClassList = {
        'ALL_PRODUCT': [], // 全部商品頁的商品列表 (商品資訊為簡易版)
        'HOME': [], // 首頁的商品列表 (商品資訊為簡易版)
        'MODAL': [], // 快速下單、更改商品等modal的商品列表 (商品資訊為完整版)
        'OFFER': [], // 報價單的商品列表 (商品資訊為完整版)
        'MOBILE': [], // 手機版的商品列表 (商品資訊為簡易版)
        'MOBILE_FULL': [], // 手機版更改商品的商品列表 (商品資訊為完整版)
    };

    // -------------------------------
    // format 全部商品頁面的商品列表
    // -------------------------------
    var formatAllProductPdtClassList = function(productClassListLite) {

        var complexPdtMap = productClassListLite.complexPdtMap;
        var pdtSpecClassMap = productClassListLite.pdtSpecClassMap;
        var pdtClass_ProductMap = productClassListLite.pdtClass_ProductMap;

        var covertPdtClassListToWebResult = function(data) {

            var _pdtClassList = [];
                mainPdtClasses = data.mainPdtClass;

            for(var i = 0 ; i < mainPdtClasses.length ; i++) {
                var mainPdtClass = covertMainPdtClassToWebResult(mainPdtClasses[i]);
                if(mainPdtClass) {
                    mainPdtClass = expendBlockProduct(mainPdtClass);

                    _pdtClassList.push(mainPdtClass);
                }
            }

            return _pdtClassList;
        }

        var covertMainPdtClassToWebResult = function(mainPdtClass) {

            if(Array.isArray(mainPdtClass.pdtClassList) && mainPdtClass.pdtClassList.length > 0) {
                mainPdtClass.pdtClasses = [];
                mainPdtClass.products = [];
                for(var i = 0 ; i < mainPdtClass.pdtClassList.length ; i++) {
                    var pdtClassString = mainPdtClass.pdtClassList[i];
                    var pdtClass = pdtSpecClassMap[pdtClassString];

                    if(!pdtClass) {
                        continue;
                    }

                    var _products = pdtClass_ProductMap[pdtClassString];
                    
                    if(Array.isArray(_products) && _products.length > 0) {

                        var products = formatProducts(_products);

                        var labelclass = products[0].labelclass;

                        // 檢查全部的標籤，全部一樣則顯示在子分類
                        for(var j = 0; j < products.length; j++) {
                            if(products[j].labelclass != labelclass) {
                                labelclass = undefined;
                                break;
                            }
                        }

                        if(labelclass) {
                            pdtClass.labelclass = labelclass + ' show-tip ';
                        } else {
                            for(var j = 0; j < products.length; j++) {
                                products[j].labelclass += ' show-tip ';
                            }
                        }

                        // 補上最低價
                        var minUnitPrice = -1, minPrintingUnit = undefined;

                        for(var j = 0; j < products.length; j++) {

                            if(minUnitPrice == -1 || minUnitPrice > products[j].minUnitPrice) {
                                minUnitPrice = products[j].minUnitPrice;
                                minPrintingUnit = products[j].minPrintingUnit;
                            }
                        }

                        if(minUnitPrice != -1 && minPrintingUnit) {
                            pdtClass.minUnitPrice = minUnitPrice;
                            pdtClass.minPrintingUnit = minPrintingUnit;
                        }

                        pdtClass.products = products;
                        mainPdtClass.pdtClasses.push(pdtClass);
                        Array.prototype.push.apply(mainPdtClass.products, products);

                    } else {
                        continue;
                    }                    
                }

                if(mainPdtClass.products.length > 0) {
                    return mainPdtClass;
                } else {
                    return;
                }
            } else {
                return;
            }            
        }

        var formatProducts = function(products) {

            var complexMap = {};
            var _products = [];

            for(var i = 0; i < products.length; i++) {
                var product = products[i];
                product.isComplex = false;
                product.resultName = product.name;

                // 判斷是否為複合商品
                if(product.complexidList && product.complexidList.length > 0) {
                    
                    product.isComplex = true;
                    product.complexname = product.name;

                    var complexid = product.complexidList[0];

                    if(complexPdtMap[complexid] && complexMap[complexid] == undefined) {

                        complexMap[complexid] = i;

                        var _product = shallowCopy(product);

                        product.complex = complexPdtMap[complexid];
                        product.name = product.complex.name;
                        product.complex.productList = [];
                        product.complex.productList.push(_product);
                        
                        product.complexname = product.complex ? product.complex.name : product.name;
                        product.resultName = product.complexname;

                    } else if(complexPdtMap[complexid]){

                        products[complexMap[complexid]].complex.productList.push(product);
                        continue;
                    }
                }

                if(product.isComplex) {
                    product.linkurl = $state.href(window.STATES.COMPLEX_PDT, {complexid: product.complexidList[0] ,productid: product.productid});
                } else {
                    product.linkurl = $state.href(window.STATES.PRODUCT, {productid: product.productid});
                }

                _products.push(product);
            }

            if(_products.length > 0) {
                // 檢查商品標籤
                loop1: 
                for(var i = 0; i < _products.length; i++) {
                    var product = _products[i];
                    var label = product.label;

                    if(product.isComplex && label > 0) {
                        loop2:
                        for(var j = 0; j < product.complex.productList.length; j++) {
                            if(label != product.complex.productList[j].label) {
                                continue loop1;
                            }
                        }
                    }

                    switch(label) {
                        case 1:
                            product.labelclass = ' new ';
                            break;
                        case 2:
                            product.labelclass = ' recommend ';
                            break;
                        case 4:
                            product.labelclass = ' hot ';
                            break;
                        case 8:
                            product.labelclass = ' free-shipping ';
                            break;
                        default:
                            product.labelclass = '';
                            break;
                    }
                }
            }

            return _products;
        }

        var expendBlockProduct = function(mainPdtClass) {

            // 把分類內的商品列出來
            if(mainPdtClass.pdtClasses && mainPdtClass.pdtClasses.length > 0) {
                mainPdtClass.blockProducts = [];

                for(var i = 0; i < mainPdtClass.pdtClasses.length; i++) {
                    var pdtClass = mainPdtClass.pdtClasses[i];

                    if(pdtClass.products && pdtClass.products.length > 0) {
                        for(var j = 0; j < pdtClass.products.length; j++) {
                            mainPdtClass.blockProducts.push(pdtClass.products[j]);            
                        }
                    }
                }
            }

            return mainPdtClass;
        }

        pdtClassList['ALL_PRODUCT'] = covertPdtClassListToWebResult(productClassListLite);

        return pdtClassList['ALL_PRODUCT'];
    }

    // -------------------------------
    // format 首頁的商品列表
    // -------------------------------
    var formatHomePdtClassList = function(productClassListLite, classifiedADMap) {

        var complexPdtMap = productClassListLite.complexPdtMap;
        var pdtSpecClassMap = productClassListLite.pdtSpecClassMap;
        var pdtClass_ProductMap = productClassListLite.pdtClass_ProductMap;

        var covertPdtClassListToWebResult = function(result) {

            var _pdtClassList = [];
                mainPdtClasses = result.mainPdtClass;;

            for(var i = 0 ; i < mainPdtClasses.length ; i++) {
                var mainPdtClass = covertMainPdtClassToWebResult(mainPdtClasses[i]);
                if(!mainPdtClass) {
                    continue;
                }
                if(classifiedADMap) {
                    var classADs = classifiedADMap[mainPdtClass.mainPdtClassID];

                    if(Array.isArray(classADs) && classADs.length > 0) {
                        mainPdtClass.classADs = [];
                        mainPdtClass.classADs.push(classADs[0]);

                        if(classADs.length > 1) {
                            mainPdtClass.classADs.push(classADs[1]);
                        }
                    }
                } 
                mainPdtClass = expendBlockProduct(mainPdtClass);

                _pdtClassList.push(mainPdtClass);
            }

            return _pdtClassList;
        }

        var covertMainPdtClassToWebResult = function(mainPdtClass) {

            if(Array.isArray(mainPdtClass.pdtClassList) && mainPdtClass.pdtClassList.length > 0) {
                mainPdtClass.pdtClasses = [];
                mainPdtClass.products = [];
                for(var i = 0 ; i < mainPdtClass.pdtClassList.length ; i++) {
                    var pdtClassString = mainPdtClass.pdtClassList[i];
                    var pdtClass = pdtSpecClassMap[pdtClassString];

                    if(!pdtClass) {
                        continue;
                    }

                    var _products = pdtClass_ProductMap[pdtClassString];
                    if(Array.isArray(_products) && _products.length > 0) {

                        var products = formatProducts(_products);

                        var labelclass = products[0].labelclass;
                        // 檢查全部的標籤，全部一樣則顯示在子分類
                        for(var j = 0; j < products.length; j++) {
                            if(products[j].labelclass != labelclass) {
                                labelclass = undefined;
                                break;
                            }
                        }

                        if(labelclass) {
                            pdtClass.labelclass = labelclass + ' show-tip ';
                        } else {
                            for(var j = 0; j < products.length; j++) {
                                products[j].labelclass += ' show-tip ';
                            }
                        }

                        pdtClass.products = products;

                        if(pdtClass.products.length == 1) {
                            pdtClass.linkurl = pdtClass.products[0].linkurl;

                            if(!pdtClass.coverurl && pdtClass.products[0].homeCover) {
                                pdtClass.coverurl = pdtClass.products[0].homeCover;
                            }

                            if(!pdtClass.mobileCoverurl && pdtClass.products[0].covers && pdtClass.products[0].covers.length > 0) {
                                pdtClass.mobileCoverurl = pdtClass.products[0].covers[0];
                            }

                        } else {
                            pdtClass.linkurl = $state.href(window.STATES.PRODUCT_LIST, {class: pdtClass.urlParamName});
                        }

                        mainPdtClass.pdtClasses.push(pdtClass);
                        Array.prototype.push.apply(mainPdtClass.products, products);

                    } else {
                        continue;
                    }                    
                }

                if(mainPdtClass.products.length > 0) {
                    return mainPdtClass;
                } else {
                    return;
                }
            } else {
                return;
            }            
        }

        var formatProducts = function(products) {

            var complexMap = {};
            var _products = [];

            for(var i = 0; i < products.length; i++) {
                var product = products[i];
                product.isComplex = false;
                product.resultName = product.name;

                // 判斷是否為複合商品
                if(product.complexidList && product.complexidList.length > 0) {

                    product.isComplex = true;
                    product.complexname = product.name;

                    var complexid = product.complexidList[0];

                    if(complexPdtMap[complexid] && complexMap[complexid] == undefined) {

                        complexMap[complexid] = i;

                        var _product = shallowCopy(product);

                        product.complex = complexPdtMap[complexid];
                        product.name = product.complex.name;
                        product.complex.productList = [];
                        product.complex.productList.push(_product);
                        
                        product.complexname = product.complex ? product.complex.name : product.name;
                        product.resultName = product.complexname;

                    } else if(complexPdtMap[complexid]){

                        products[complexMap[complexid]].complex.productList.push(product);
                        continue;
                    }
                }

                if(product.isComplex) {
                    product.linkurl = $state.href(window.STATES.COMPLEX_PDT, {complexid: product.complexidList[0] ,productid: product.productid});
                } else {
                    product.linkurl = $state.href(window.STATES.PRODUCT, {productid: product.productid});
                }

                _products.push(product);
            }

            if(_products.length > 0) {
                // 檢查商品標籤
                loop1: 
                for(var i = 0; i < _products.length; i++) {
                    var product = _products[i];
                    var label = product.label;

                    if(product.isComplex && label > 0) {
                        loop2:
                        for(var j = 0; j < product.complex.productList.length; j++) {
                            if(label != product.complex.productList[j].label) {
                                continue loop1;
                            }
                        }
                    }

                    switch(label) {
                        case 1:
                            product.labelclass = ' new ';
                            break;
                        case 2:
                            product.labelclass = ' recommend ';
                            break;
                        case 4:
                            product.labelclass = ' hot ';
                            break;
                        case 8:
                            product.labelclass = ' free-shipping ';
                            break;
                        default:
                            product.labelclass = '';
                            break;
                    }
                }
            }
            
            return _products;
        }

        var expendBlockProduct = function(mainPdtClass) {

            if(!mainPdtClass.pdtClasses) {
                return mainPdtClass;
            }

            // 最多呈現數量，畫面上有八格，但最後一格要放查看商品
            mainPdtClass.showMax = 11;
            if(mainPdtClass.pdtClasses.length == 12) {
                mainPdtClass.showMax = 12;
            }

            // 子分類過少就把商品列出來
            if(mainPdtClass.pdtClasses.length > 0 && mainPdtClass.pdtClasses.length < 11) {
                mainPdtClass.blockProducts = [];

                for(var i = 0; i < mainPdtClass.pdtClasses.length; i++) {
                    var pdtClass = mainPdtClass.pdtClasses[i];

                    if(pdtClass.products && pdtClass.products.length > 0) {
                        for(var j = 0; j < pdtClass.products.length; j++) {
                            mainPdtClass.blockProducts.push(pdtClass.products[j]);            
                        }
                    }
                }

                var pdtsize = mainPdtClass.blockProducts.length;

                if(pdtsize <= 2) {
                    mainPdtClass.itemextraclass = ' product-item-50-width ';
                }

                // 檢查裡面商品數量，如果少於12大於7，就讓他呈現兩排就好，所以上限要改為8
                if(pdtsize > 8 && pdtsize < 12) {
                    mainPdtClass.showMax = 7;
                } else if(pdtsize == 8) {
                    mainPdtClass.showMax = 8;
                // 檢查裡面商品數量，如果少於7，就讓他呈現一排就好，所以上限要改為3
                } else if(pdtsize < 7) {
                    mainPdtClass.showMax = 3;
                    if(pdtsize == 4) {
                        mainPdtClass.showMax = 4;
                    } else if(pdtsize < 4) {
                        mainPdtClass.hideBlock = true;
                    }
                } 

            } else if(mainPdtClass.pdtClasses.length > 0) {
                // 取得分類最低價
                for(var i = 0; i < mainPdtClass.pdtClasses.length; i++) {
                    var pdtClass = mainPdtClass.pdtClasses[i];

                    if(pdtClass.products && pdtClass.products.length > 0) {
                        pdtClass.minUnitPrice = undefined;
                        pdtClass.minPrintingUnit = undefined;

                        for(var j = 0; j < pdtClass.products.length; j++) {
                            if(pdtClass.minUnitPrice === undefined || pdtClass.minUnitPrice > pdtClass.products[j].minUnitPrice) {
                                pdtClass.minUnitPrice = pdtClass.products[j].minUnitPrice;
                                pdtClass.minPrintingUnit = pdtClass.products[j].minPrintingUnit;
                            }
                        }
                    }
                }
            }

            // 不管怎樣都先改成最多顯示12筆
            mainPdtClass.showMax = 12;
            
            if(Array.isArray(mainPdtClass.classADs) && mainPdtClass.classADs.length > 0) {
                mainPdtClass.hideBlock = false;
                mainPdtClass.showMax -= (2 * mainPdtClass.classADs.length);
                mainPdtClass.showMax = mainPdtClass.showMax < 0 ? 0 : mainPdtClass.showMax;
            }

            return mainPdtClass;
        }

        pdtClassList['HOME'] = covertPdtClassListToWebResult(productClassListLite);
        return pdtClassList['HOME'];
    }

    // -------------------------------
    // format Modal的商品列表
    // -------------------------------
    var formatModalPdtClassList = function(productClassList) {

        var complexPdtMap = productClassList.complexPdtMap;
        var pdtSpecClassMap = productClassList.pdtSpecClassMap;
        var pdtClass_ProductMap = productClassList.pdtClass_ProductMap;

        var covertPdtClassListToWebResult = function(result) {
            var _pdtClassList = [];
                mainPdtClasses = result.mainPdtClass;

            for(var i = 0 ; i < mainPdtClasses.length ; i++) {
                var mainPdtClass = covertMainPdtClassToWebResult(mainPdtClasses[i]);
                if(mainPdtClass) {
                    _pdtClassList.push(mainPdtClass);
                }
            }

            return _pdtClassList;
        }

        var covertMainPdtClassToWebResult = function(mainPdtClass) {
            if(Array.isArray(mainPdtClass.pdtClassList) && mainPdtClass.pdtClassList.length > 0) {
                mainPdtClass.pdtClasses = [];
                for(var i = 0 ; i < mainPdtClass.pdtClassList.length ; i++) {
                    var pdtClassString = mainPdtClass.pdtClassList[i];
                    var pdtClass = pdtSpecClassMap[pdtClassString];

                    if(!pdtClass) {
                        continue;
                    }

                    var _products = pdtClass_ProductMap[pdtClassString];
                    if(Array.isArray(_products) && _products.length > 0) {

                        var products = formatProducts(_products);

                        pdtClass.products = products;
                        mainPdtClass.pdtClasses.push(pdtClass);
                    } else {
                        continue;
                    }                    
                }

                return mainPdtClass;
            } else {
                return;
            }            
        }

        var formatProducts = function(products) {

            var complexMap = {};
            var _products = [];

            for(var i = 0; i < products.length; i++) {
                var product = products[i];
                product.isComplex = false;
                product.selectedid = product.productid;

                // 判斷是否為複合商品
                if(product.complexidList && product.complexidList.length > 0) {

                    product.isComplex = true;

                    var complexid = product.complexidList[0];

                    if(complexPdtMap[complexid] && complexMap[complexid] == undefined) {

                        product.selectedid = complexid;
                        complexMap[complexid] = i;

                        var _product = shallowCopy(product);

                        product.complex = complexPdtMap[complexid];
                        product.name = product.complex.name;
                        product.complex.productList = [];
                        product.complex.productList.push(_product);

                    } else if(complexPdtMap[complexid]){

                        product.selectedid = complexid;
                        products[complexMap[complexid]].complex.productList.push(product);
                        continue;
                    }
                }

                _products.push(product);
            }

            return _products;
        }

        pdtClassList['MODAL'] = covertPdtClassListToWebResult(productClassList);
        return pdtClassList['MODAL'];
    }

    // -------------------------------
    // format 報價單的商品列表
    // -------------------------------
    var formatOfferPdtClassList = function(productClassList, customMainPdtClass) {

        var pdtSpecClassMap = productClassList.pdtSpecClassMap;
        var pdtClass_ProductMap = productClassList.pdtClass_ProductMap;

        var covertPdtClassListToWebResult = function(result) {

            var _pdtClassList = [];
                mainPdtClasses = result.mainPdtClass;

            for(var i = 0 ; i < mainPdtClasses.length ; i++) {
                var mainPdtClass = covertMainPdtClassToWebResult(mainPdtClasses[i]);
                if(mainPdtClass && mainPdtClass.pdtClasses && mainPdtClass.pdtClasses.length > 0) {
                    _pdtClassList.push(mainPdtClass);
                }
            }

            _pdtClassList.push(customMainPdtClass);

            return _pdtClassList;
        }

        var covertMainPdtClassToWebResult = function(mainPdtClass) {

            if(Array.isArray(mainPdtClass.pdtClassList) && mainPdtClass.pdtClassList.length > 0) {
                mainPdtClass.pdtClasses = [];
                for(var i = 0 ; i < mainPdtClass.pdtClassList.length ; i++) {
                    var pdtClassString = mainPdtClass.pdtClassList[i];
                    var pdtClass = pdtSpecClassMap[pdtClassString];

                    if(!pdtClass) {
                        continue;
                    }

                    var _products = pdtClass_ProductMap[pdtClassString];
                    if(Array.isArray(_products) && _products.length > 0) {
                        pdtClass.products = [];
                        // 移除急件商品
                        for(var j = 0; j < _products.length; j++) {
                            var product = _products[j];
                            pdtClass.products.push(product);
                        }

                        if(pdtClass.products.length > 0) {
                            mainPdtClass.pdtClasses.push(pdtClass);
                        }
                    } else {
                        continue;
                    }                    
                }

                return mainPdtClass;
            } else {
                return;
            }            
        }

        pdtClassList['OFFER'] = covertPdtClassListToWebResult(productClassList);
        return pdtClassList['OFFER'];
    }

    // -------------------------------
    // format 手機版的商品列表
    // -------------------------------
    var formatMobilePdtClassList = function(productClassListLite) {

        var complexPdtMap = productClassListLite.complexPdtMap;
        var pdtSpecClassMap = productClassListLite.pdtSpecClassMap;
        var pdtClass_ProductMap = productClassListLite.pdtClass_ProductMap;

        var covertPdtClassListToWebResult = function(result) {

            var _pdtClassList = [];
                mainPdtClasses = result.mainPdtClass;;

            for(var i = 0 ; i < mainPdtClasses.length ; i++) {
                var mainPdtClass = covertMainPdtClassToWebResult(mainPdtClasses[i]);
                if(mainPdtClass) {
                    _pdtClassList.push(mainPdtClass);
                }
            }

            return _pdtClassList;
        }

        var covertMainPdtClassToWebResult = function(mainPdtClass) {

            if(Array.isArray(mainPdtClass.pdtClassList) && mainPdtClass.pdtClassList.length > 0) {
                mainPdtClass.pdtClasses = [];
                mainPdtClass.products = [];
                for(var i = 0 ; i < mainPdtClass.pdtClassList.length ; i++) {
                    var pdtClassString = mainPdtClass.pdtClassList[i];
                    var pdtClass = pdtSpecClassMap[pdtClassString];

                    if(!pdtClass) {
                        continue;
                    }

                    var _products = pdtClass_ProductMap[pdtClassString];
                    if(Array.isArray(_products) && _products.length > 0) {

                        var products = formatProducts(_products);

                        if(Array.isArray(products) && products.length > 0) {
                            var labelclass = products[0].labelclass;
                            // 檢查全部的標籤，全部一樣則顯示在子分類
                            for(var j = 0; j < products.length; j++) {
                                if(products[j].labelclass != labelclass) {
                                    labelclass = undefined;
                                    break;
                                }
                            }

                            if(labelclass) {
                                pdtClass.labelclass = labelclass + ' show-tip ';
                            } else {
                                for(var j = 0; j < products.length; j++) {
                                    products[j].labelclass += ' show-tip ';
                                }
                            }

                            pdtClass.products = products;
                            mainPdtClass.pdtClasses.push(pdtClass);
                            Array.prototype.push.apply(mainPdtClass.products, products);
                        }
                    } else {
                        continue;
                    }                    
                }

                if(mainPdtClass.products.length > 0) {
                    return mainPdtClass;
                } else {
                    return;
                }
            } else {
                return;
            }            
        }

        var formatProducts = function(products) {

            var complexMap = {};
            var _products = [];

            for(var i = 0; i < products.length; i++) {
                var product = products[i];

                product.isComplex = false;
                product.resultName = product.name;

                // 判斷是否為複合商品
                if(product.complexidList && product.complexidList.length > 0) {

                    product.isComplex = true;
                    product.complexname = product.name;

                    var complexid = product.complexidList[0];

                    if(complexPdtMap[complexid] && complexMap[complexid] == undefined) {

                        complexMap[complexid] = i;

                        var _product = shallowCopy(product);

                        product.complex = complexPdtMap[complexid];
                        product.name = product.complex.name;
                        product.complex.productList = [];
                        product.complex.productList.push(_product);

                        product.complexname = product.complex ? product.complex.name : product.name;
                        product.resultName = product.complexname;

                    } else if(complexPdtMap[complexid]){
                        products[complexMap[complexid]].complex.productList.push(product);
                        continue;
                    }
                }

                if(product.isComplex) {
                    product.linkurl = $state.href(window.STATES.COMPLEX_PDT, {complexid: product.complexidList[0] ,productid: product.productid});
                } else {
                    product.linkurl = $state.href(window.STATES.PRODUCT, {productid: product.productid});
                }

                _products.push(product);
            }

            if(_products.length > 0) {
                // 檢查商品標籤
                loop1: 
                for(var i = 0; i < _products.length; i++) {
                    var product = _products[i];
                    var label = product.label;

                    if(product.isComplex && label > 0) {
                        loop2:
                        for(var j = 0; j < product.complex.productList.length; j++) {
                            if(label != product.complex.productList[j].label) {
                                continue loop1;
                            }
                        }
                    }

                    switch(label) {
                        case 1:
                            product.labelclass = ' new ';
                            break;
                        case 2:
                            product.labelclass = ' recommend ';
                            break;
                        case 4:
                            product.labelclass = ' hot ';
                            break;
                        case 8:
                            product.labelclass = ' free-shipping ';
                            break;
                        default:
                            product.labelclass = '';
                            break;
                    }
                }
            }

            return _products;
        }

        pdtClassList['MOBILE'] = covertPdtClassListToWebResult(productClassListLite);
        return pdtClassList['MOBILE'];
    }

    // -------------------------------
    // format 手機版更改商品的商品列表
    // -------------------------------
    var formatMobileFullPdtClassList = function(productClassList) {

        var complexPdtMap = productClassList.complexPdtMap;
        var pdtSpecClassMap = productClassList.pdtSpecClassMap;
        var pdtClass_ProductMap = productClassList.pdtClass_ProductMap;

        var covertPdtClassListToWebResult = function(result) {

            var _pdtClassList = [];
                mainPdtClasses = result.mainPdtClass;

            for(var i = 0 ; i < mainPdtClasses.length ; i++) {
                var mainPdtClass = covertMainPdtClassToWebResult(mainPdtClasses[i]);
                if(mainPdtClass) {
                    _pdtClassList.push(mainPdtClass);
                }
            }

            return _pdtClassList;
        }

        var covertMainPdtClassToWebResult = function(mainPdtClass) {

            if(Array.isArray(mainPdtClass.pdtClassList) && mainPdtClass.pdtClassList.length > 0) {
                mainPdtClass.pdtClasses = [];
                mainPdtClass.products = [];
                for(var i = 0 ; i < mainPdtClass.pdtClassList.length ; i++) {
                    var pdtClassString = mainPdtClass.pdtClassList[i];
                    var pdtClass = pdtSpecClassMap[pdtClassString];

                    if(!pdtClass) {
                        continue;
                    }

                    var _products = pdtClass_ProductMap[mainPdtClass.pdtClassList[i]];
                    if(Array.isArray(_products) && _products.length > 0) {

                        var products = formatProducts(_products);

                        pdtClass.products = products;
                        mainPdtClass.pdtClasses.push(pdtClass);
                    } else {
                        continue;
                    }
                }
                
                return mainPdtClass;
            } else {
                return;
            }            
        }

        var formatProducts = function(products) {

            var complexMap = {};
            var _products = [];

            for(var i = 0; i < products.length; i++) {
                var product = products[i];

                product.isComplex = false;
                product.selectedid = product.productid;

                // 判斷是否為複合商品
                if(product.complexidList && product.complexidList.length > 0) {

                    product.isComplex = true;

                    var complexid = product.complexidList[0];

                    if(complexPdtMap[complexid] && complexMap[complexid] == undefined) {

                        product.selectedid = complexid;
                        complexMap[complexid] = i;

                        var _product = shallowCopy(product);

                        product.complex = complexPdtMap[complexid];
                        product.name = product.complex.name;
                        product.complex.productList = [];
                        product.complex.productList.push(_product);

                    } else if(complexPdtMap[complexid]){

                        product.selectedid = complexid;
                        products[complexMap[complexid]].complex.productList.push(product);
                        continue;
                    }
                }

                _products.push(product);
            }

            return _products;
        }

        pdtClassList['MOBILE_FULL'] = covertPdtClassListToWebResult(productClassList);
        return pdtClassList['MOBILE_FULL'];
    }

    // -------------------------------
    // 取得 format 過的商品列表
    // -------------------------------
    var getPdtClassList = function(listType) {

        if(!listType) {
            return [];
        }

        return pdtClassList[listType];
    }

    /*-------------------------
        Members
    -------------------------*/

    /*-------------------------
        Methods
    -------------------------*/
    factory.formatAllProductPdtClassList = formatAllProductPdtClassList; // format 全部商品頁面的商品列表
    factory.formatHomePdtClassList = formatHomePdtClassList; // format 全部商品頁面的商品列表
    factory.formatModalPdtClassList = formatModalPdtClassList; // format Modal的商品列表
    factory.formatOfferPdtClassList = formatOfferPdtClassList; // format 報價單的商品列表
    factory.formatMobilePdtClassList = formatMobilePdtClassList; // format 手機版的商品列表
    factory.formatMobileFullPdtClassList = formatMobileFullPdtClassList; // format 手機版更改商品的商品列表
    factory.getPdtClassList = getPdtClassList; // 取得 format 過的全部商品列表

    return factory;
}]);